import TFCookies from '../enums/tf-cookies';
import { CountriesInfo } from '../utils/countries-info';
import CookieService from './cookie.service';

export const getCountry = () => {
  let country = CookieService.getCookie(TFCookies.CODE.ISO);
  if (!country) country = process.env.REACT_APP_DEFAULT_COUNTRY;
  return country;
}

export const getLang = () => {
  let lang = CookieService.getCookie(TFCookies.CODE.LANG);
  if (!lang) lang = process.env.REACT_APP_DEFAULT_LANG;
  return lang;
}

export const getLocale = () => {
  return `${getLang()}_${getCountry()?.toUpperCase()}`;
}

export const getDefaultLocale = () => {
  return `${process.env.REACT_APP_DEFAULT_LANG}_${process.env.REACT_APP_DEFAULT_COUNTRY?.toUpperCase()}`;
}

export const getDisplayType = () => {
  return CookieService.getCookie(TFCookies.CODE.DISPLAY_TYPE);
}

export const currentCountryInfo = () => {
  const country = getCountry();
  return CountriesInfo[country];
};